import { render, staticRenderFns } from "./QuestionOption.vue?vue&type=template&id=611c0f6a&scoped=true&"
import script from "./QuestionOption.vue?vue&type=script&lang=ts&"
export * from "./QuestionOption.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionOption.vue?vue&type=style&index=0&id=611c0f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611c0f6a",
  null
  
)

export default component.exports